import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { useEffect, useState } from "react";
import { JVDate } from "../../shared/JVDate";
import { JVInput } from "../../shared/JVInput";
import { IUsersDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";

export interface IAllHisFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    req_ID?: number | null | string,
    recruiter_ID?: number | null
}

export const EmptyAllHisFilter: IAllHisFilter = {
    fromDate: new Date,
    toDate: new Date,
    req_ID: "",
    recruiter_ID: null
}

interface Iprops {
    // open: boolean,
    // hideDialog: () => void,
    // toast: any,
    allHisFilter: IAllHisFilter,
    setAllHisFilter: (allHisFilter: IAllHisFilter) => void
}

export const Filter = (props: Iprops) => {
    const [rc, setRC] = useState<Array<IUsersDropdown>>();




    const { control, handleSubmit, reset } = useForm<IAllHisFilter>({
        defaultValues: props.allHisFilter,
        shouldFocusError: false
    });

    const loadRc = async () => {
        const response = await Fetch("Dropdown/UsersByRole", "GET", null, `role_id=${3}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRC(data);
        }
    }
    useEffect(() => {
        loadRc();
    }, []);


    const searchToDB = async (body: IAllHisFilter) => {
        // onHide();
        let filterData: any = body;
        let emptyFilter: any = EmptyAllHisFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setAllHisFilter(body);
    }

    // const onHide = () => {
    //     props.hideDialog();
    // }

    function onSubmit(data: IAllHisFilter) {
        searchToDB(data);
    }

    return (
        // <Dialog visible={props.open} style={{ width: '80vw' }} header="Search Recruiter Efficiency" modal className="p-fluid" onHide={onHide}>
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
            <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
            <JVInput type="number" column={6} label="Req ID" control={control} name="req_ID" />
            <JVDropdown column={6} label="Recruiter" control={control} name="recruiter_ID" options={rc} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" />
            <div style={{ margin: '10px 0', width: '100%' }}></div>

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyAllHisFilter) }} type="button"></Button>
            </div>
        </form>
    );
}
